import { Component, OnInit } from '@angular/core';
import { Cuotas } from 'src/app/global/interfaces/cuotas';
import { CuotasResponse } from 'src/app/global/interfaces/cuotas-response';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { FlujosPaso3Service } from 'src/app/global/services/flujos-paso-3.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { CuotasServiceVM } from 'src/app/view-model/services/cuotas.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';

@Component({
  selector: 'app-cuotas-tbk',
  templateUrl: './cuotas-tbk.component.html',
  styleUrls: ['./cuotas-tbk.component.scss']
})
export class CuotasTbkComponent implements OnInit {

  public conCuotas = false;
  public showCuotasInfo = false;
  public cambioFlecha: string;
  public bloqCuotas = false;
  puedeEditar: boolean;
  dataPaso3: Paso3;


  get flujo() {return this.flujo3Service.configuracionCuotas; }

  constructor(private cuotasService: CuotasServiceVM, private flujo3Service: FlujosPaso3Service,
              private anexoContrato: AnexoContratoServiceVM, private cuentaAbonoSubject: CuentaAbonoSubject,
              private localStorageService: LocalStorageService, private valEdicionSer: ValidacionEdicionServiceVM,
              private tagManagerService: TagManagerService) {

  }

  ngOnInit() {
    this.cambioFlecha = 'icon-menu-up';
    this.dataPaso3 = this.localStorageService.getPaso3();
    this.conCuotas = this.dataPaso3.datoCuota.data;
    this.puedeEditar = this.dataPaso3.validaPaso3.data;

    this.valEdicionSer.getValidacion$.subscribe( resp => {
      if (resp !== null) {
        this.puedeEditar = resp;
        this.dataPaso3.validaPaso3.data = resp;
      }
    });
    // scroll at Top
    window.scrollTo(0, 0);
    // this.getCuotas();
  }


  private getCuotas(): void {
    const cbOK = (response: CuotasResponse) => {
      this.conCuotas = response.data;
      this.flujo3Service.configuracionCuotas.cargando = false;
      this.flujo3Service.configuracionCuotas.mostrar = true;
      this.flujo3Service.configuracionCuotas.ok = true;
    };

    const cbError = error => {
      console.error(error);
    };

    this.cuotasService.getCuotas().subscribe(cbOK, cbError);
  }

  public changeCuotas() {
    this.saveCuotas();
  }

  private saveCuotas() {
    this.bloqCuotas = true;
    const data: Cuotas = {
      aceptaCuotas: this.conCuotas
    };

    if (!this.conCuotas) {
      this.tagManagerService.logCuotas();
    }

    const cbOK = () => {
      this.dataPaso3.datoCuota.data = this.conCuotas;
      this.localStorageService.setPaso3(this.dataPaso3);
      this.tipoAprobacion();
    };

    const cbError = error => {
      this.bloqCuotas = false;
      console.error(error);
    };

    this.cuotasService.postCuotas(data).subscribe(cbOK, cbError);

  }

  public showInfo() {
    if (this.showCuotasInfo) {
      this.showCuotasInfo = false;
      this.cambioFlecha = 'icon-menu-up';
    } else {
      this.showCuotasInfo = true;
      this.cambioFlecha = 'icon-menu-up clicked';
      let gevent = GoogleTagManager.eventInteracciones().categoriaDetalleContratacion().accionClick();
      this.tagManagerService.logEvent(gevent.setEtiqueta("¿Qué son las cuotas Transbank?").setIsPersonaNatural(this.localStorageService.getPaso1().currentIsPersonaNatural))
    }
  }

  private tipoAprobacion() {

    const cbOK = response => {
      this.bloqCuotas = false;
      this.flujo3Service.configuracionCuotas.ok = true;
      if (response.tipoAprobacion === 'ACEPTA_TERMINOS_Y_CONDICIONES') {
        this.cuentaAbonoSubject.showTerminosyCondiciones();
      } else {
        this.cuentaAbonoSubject.showAnexoContrato();
      }
    };

    const cbError = error => {
      console.error(error);
    };

    return this.anexoContrato.getTipoAprobacion().subscribe(cbOK, cbError);
  }





}
